export default function ({ app, store, $axios, redirect, $config }) {
  // Only run on client side
  if (process.server) {
    return
  }

  // Inject auth methods into Vue instance
  app.$auth = {
    async checkAuthStatus(forceRefresh = false) {
      // Use store action which handles localStorage caching
      return store.dispatch('auth/checkAuthStatus', { forceRefresh })
    },
    
    async refreshAuthStatus() {
      return store.dispatch('auth/refreshAuthStatus')
    },

    async login(username, password) {
      try {
        const authUrl = $config.authUrl || process.env.AUTH_URL || 'http://localhost:9000'
        const response = await $axios.post(`${authUrl}/login`, {
          username,
          password
        }, {
          withCredentials: true
        })
        
        if (response.data) {
          // Force refresh to get fresh user data and save to localStorage
          await this.checkAuthStatus(true)
          redirect('/')
        }
      } catch (error) {
        throw new Error('Invalid credentials')
      }
    },

    async logout() {
      try {
        const authUrl = $config.authUrl || process.env.AUTH_URL || 'http://localhost:9000'
        await $axios.post(`${authUrl}/logout`, {}, {
          withCredentials: true
        })
      } catch (error) {
        // Continue with logout even if request fails
      } finally {
        // clearAuth mutation will also clear localStorage
        store.commit('auth/clearAuth')
        redirect('/login')
      }
    },

    get isAuthenticated() {
      return store.getters['auth/isLoggedIn']
    },

    get user() {
      return store.getters['auth/currentUser']
    }
  }
}

